import axios from "~/axios";

const login = async(baseUrl) => {
    return (await axios.post(`${baseUrl}/logout`)).data;
};

export default login;